import React from 'react';
import { stockState } from './model';
import './style.css';

export function StockBox({ product, children }) {
    const stock = stockState(product);
    const warning = stock?.color;
    const description = stock ? `موجودی فعلی ${stock.level}؛ حد هشدار ${stock.threshold ?? 'نامشخص'}` : undefined;
    return (
        <span className={`stock-indicator-box${warning ? ` stock-indicator-box--${warning}` : ''}`}
            data-stock-indicator="current" title={description}>
            <span className="stock-indicator-box__value">{children}</span>
        </span>
    );
}

export function StockSuggestion({ suggestion }) {
    const bracketStart = suggestion.name.lastIndexOf(' [ ');
    if (bracketStart < 0) return <span>{suggestion.name}</span>;
    return (
        <span className="stock-indicator-suggestion">
            <span className="stock-indicator-suggestion__name">{suggestion.name.slice(0, bracketStart)}</span>
            <StockBox product={suggestion}>
                {suggestion.name.slice(bracketStart + 3, -2)}
            </StockBox>
        </span>
    );
}

export default function StockIndicator({ product, quantity = 0 }) {
    const stock = stockState(product, quantity, true);
    const warning = stock?.color;
    const description = stock
        ? `موجودی پس از این سفارش ${stock.remaining}؛ موجودی فعلی ${stock.level}، حد هشدار ${stock.threshold ?? 'نامشخص'}`
        : undefined;
    return (
        <span className="stock-indicator-slot" data-stock-indicator="projected">
            <span className={`stock-indicator-dot${warning ? ` stock-indicator-dot--${warning}` : ' stock-indicator-dot--hidden'}`}
                title={warning ? description : undefined} role={warning ? 'img' : undefined}
                aria-label={warning ? description : undefined} aria-hidden={warning ? undefined : true} />
        </span>
    );
}
